<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Create Doctor</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-doctors' }">Back</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <form class="text-start mx-auto" @submit.prevent="createDoctor">
              <div class="row mb-2">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="text-">English Name</label>
                    <input type="text" class="form-control" placeholder="Enter English Name" v-model="name_en" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="labName">Arabic Name</label>
                    <input type="text" class="form-control" placeholder="Enter Arabic Name" v-model="name_ar" />
                  </div>
                </div>

                <div class="form-group col-md-4">
                  <label class="text-">English Title </label>
                  <input type="text" class="form-control" placeholder="Enter English Title " v-model="title_en" />
                </div>

                <div class="form-group col-md-4">
                  <label class="text-">Arabic Title</label>
                  <input type="text" class="form-control" placeholder="Enter Arabic Title" v-model="title_ar" />
                </div>

                <div class="form-group col-md-12 mb-2">
                  <label>English Title Type</label>
                  <select class="form-control" v-model="title_type_en">
                    <option value="">Select Title Type</option>
                    <option value="Consultant">Consultant</option>
                    <option value="Specialist">Specialist</option>
                    <option value="Professor">Professor</option>
                    <option value="Lecturer">Lecturer</option>
                  </select>
                </div>
                <div class="form-group col-md-12 mb-2">
                  <label>Arabic Title Type</label>
                  <select class="form-control" v-model="title_type_ar">
                    <option value="">Select Title Type</option>
                    <option value="استشاري">استشاري</option>
                    <option value="أخصائي">أخصائي</option>
                    <option value="أستاذ">أستاذ</option>
                    <option value="محاضر">محاضر</option>
                  </select>
                </div>
                <div class="form-group col-md-12 mb-2">
                  <label>Gender</label>
                  <select class="form-control" v-model="gender">
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                </div>
                <div class="form-group col-md-3">
                  <label class="text-">price</label>
                  <input type="number" class="form-control" placeholder="Enter price" v-model="price" />
                </div>

                <div class="form-group col-md-3">
                  <label class="text-">Price After Discount</label>
                  <input type="number" class="form-control" placeholder="Enter Price After Discount"
                    v-model="price_after_discount" />
                </div>

                <div class="form-group col-md-4">
                  <label class="text-">Experience</label>
                  <input type="number" class="form-control" placeholder="Enter Experience" v-model="experience" />
                </div>

                <div class="form-group col-md-12">
                  <label class="text-">English Description</label>
                  <textarea class="form-control" rows="3" v-model="description_en"></textarea>
                </div>

                <div class="form-group col-md-12">
                  <label class="text-">Arabic Description</label>
                  <textarea class="form-control" rows="3" v-model="description_ar"></textarea>
                </div>

                <!-- Hospital Employment Section -->
                <div class="col-md-12 mb-3">
                  <div class="card" style="background-color: #f8f9fa; border: 1px solid #dee2e6;">
                    <div class="card-body">
                      <div class="form-group">
                        <label class="font-weight-bold">
                          Is this doctor employed by the hospital?
                        </label>
                        <div class="form-check">
                          <input 
                            class="form-check-input" 
                            type="radio" 
                            name="hospitalEmployment" 
                            id="employedYes" 
                            value="yes" 
                            v-model="isHospitalEmployed">
                          <label class="form-check-label" for="employedYes">
                            Yes, the doctor is a hospital employee
                          </label>
                        </div>
                        <div class="form-check">
                          <input 
                            class="form-check-input" 
                            type="radio" 
                            name="hospitalEmployment" 
                            id="employedNo" 
                            value="no" 
                            v-model="isHospitalEmployed">
                          <label class="form-check-label" for="employedNo">
                            No, the doctor is independent/visiting
                          </label>
                        </div>
                      </div>

                      <!-- Conditional fields shown only when doctor is NOT employed by hospital -->
                      <div v-if="isHospitalEmployed === 'no'" class="mt-3">
                        <div class="alert alert-info">
                          <strong>Contact Information Required:</strong> Since this doctor is not a hospital employee, please provide their contact details.
                        </div>
                        
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="phoneNumber">Phone Number <span class="text-danger">*</span></label>
                              <input 
                                type="text" 
                                class="form-control" 
                                :class="{'is-invalid': errors.phone_number && isHospitalEmployed === 'no'}"
                                placeholder="Enter phone number" 
                                v-model="phone_number" 
                                :required="isHospitalEmployed === 'no'" />
                              <span class="error text-danger text-small" v-if="errors.phone_number && isHospitalEmployed === 'no'">
                                {{ errors.phone_number }}
                              </span>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="email">Email <span class="text-danger">*</span></label>
                              <input 
                                type="email" 
                                class="form-control" 
                                :class="{'is-invalid': errors.email && isHospitalEmployed === 'no'}"
                                placeholder="Enter email" 
                                v-model="email" 
                                :required="isHospitalEmployed === 'no'" />
                              <span class="error text-danger text-small" v-if="errors.email && isHospitalEmployed === 'no'">
                                {{ errors.email }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Message shown when doctor IS employed by hospital -->
                      <div v-else-if="isHospitalEmployed === 'yes'" class="mt-3">
                        <div class="alert alert-success">
                          <strong>Hospital Employee:</strong> Contact information will be managed through the hospital system.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label class="text-">Medical Insurances</label>
                  <multiselect v-model="selectedMedicalInsurances" :options="medicalInsurances" :searchable="true"
                    label="name_en" track-by="id" placeholder="Select Insurances" :multiple="true"></multiselect>
                  <span class="error text-small block" v-if="errors.selectedMedicalInsurances">{{
                    errors.selectedMedicalInsurances }}</span>
                </div>
                
                <div class="form-group">
                  <label> Image Upload </label>
                  <div class="fileinput fileinput-new" data-provides="fileinput">
                    <div class="fileinput-new thumbnail">
                    </div>
                    <div class="fileinput-preview fileinput-exists thumbnail"></div>
                    <div class="user-edit-image-buttons">
                      <span class="btn btn-azure btn-file"><span class="fileinput-new"><i class="fa fa-picture"></i>
                          Select image</span><span class="fileinput-exists"><i class="fa fa-picture"></i>
                          Change</span>
                        <input type="file" name="main_image" @change="handleMainImageChange" ref="imageInput" />
                      </span>
                      <a href="#" class="btn fileinput-exists btn-red" data-dismiss="fileinput"
                        @click.prevent="clearImage">
                        <i class="fa fa-times"></i> Remove
                      </a>
                    </div>
                  </div>
                  <span class="error text-small block" v-if="errors.main_image">{{
                    errors.main_image }}</span>
                </div>

                <div class="form-group">
                  <label>Additional Images</label>
                  <div class="multiple-image-upload">
                    <div class="upload-container">
                      <input type="file" class="form-control" accept="image/*" multiple @change="handleMultipleImages"
                        ref="multipleImages" />
                    </div>
                    <!-- Preview section -->
                    <div v-if="imagePreviewUrls.length" class="image-preview-container">
                      <h5>Selected Images:</h5>
                      <div class="row g-3">
                        <div v-for="(preview, index) in imagePreviewUrls" :key="index" class="col-md-3 col-sm-4 col-6">
                          <div class="image-preview-wrapper">
                            <img :src="preview" alt="Preview" class="img-thumbnail preview-image"
                              @click="removeImage(index)" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="form-group">
                  <button class="btn btn-success add-variant mb-4 p-2" @click="addDistrictVariant" type="button">
                    Add Address
                  </button>
                  <div class="row">
                    <div class="col-md-6" v-for="(variant, index) in dis_Variants" :key="index">
                      <div class="card mb-3">
                        <div class="card-body">
                          <h5 class="card-title">Address {{ index + 1 }}</h5>

                          <div class="form-group">
                            <label class="text-">Districts</label>
                            <multiselect v-model="variant.district_id" :options="districts" :searchable="true" label="name"
                              track-by="id" placeholder="Select a District" :multiple="false">
                            </multiselect>
                          </div>
                          <div class="form-group">
                            <label class="text-">Address</label>
                            <input type="text" class="form-control" placeholder="Enter Address"
                              v-model="variant.address" />
                          </div>
                          <button class="btn btn-danger mt-3" @click="removeDistrictVariant(index)">
                            Remove Address
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <button class="btn btn-success add-variant mb-3" @click="addVariant" type="button">
                    Add Variant
                  </button>
                  <span class="error text-small block" v-if="errors.data">{{
                    errors.data }}</span>
                  <div class="row">
                    <div class="col-md-6" v-for="(variant, index) in data" :key="index">
                      <div class="card mb-3">
                        <div class="card-body">
                          <h5 class="card-title">Variant {{ index + 1 }}</h5>
                          <div class="form-group col-md-12 mb-2">
                            <label>Select services</label>
                            <select class="form-control" v-model="variant.service_id" @change="handleServiceChange(variant.service_id, variant)">
                              <option value="">Select Service</option>
                              <option value="1">Hospitals</option>
                              <option value="2">Clinics</option>
                            </select>
                            <span class="error text-small block" v-if="errors[`data.${index}.sub_service_id`]">
                              {{ errors[`data.${index}.sub_service_id`][0] }}
                            </span>
                          </div>
                          <div class="form-group col-md-12 mb-2">
                            <label class="text-">Sub service</label>
                            <multiselect v-model="variant.subService_id" :options="variant.selectSubService"
                              :searchable="true" label="name" track-by="id" placeholder="Select a Sub service"
                              :multiple="false">
                            </multiselect>
                            <span class="error text-small block" v-if="errors[`data.${index}.sub_service_id`]">
                              {{ errors[`data.${index}.sub_service_id`][0] }}
                            </span>
                          </div>
                          <div class="form-group col-md-12 mb-2">
                            <label class="text-">Speciality</label>
                            <multiselect v-model="variant.specialty_id" :options="specialities" :searchable="true"
                              label="name" track-by="name" placeholder="Select a Speciality" :multiple="false">
                            </multiselect>
                            <span class="error text-small block" v-if="errors[`data.${index}.specialty_id`]">
                              {{ errors[`data.${index}.specialty_id`][0] }}
                            </span>
                          </div>
                          <div class="form-group col-md-12 mb-2">
                            <label class="text-">Hospitals/Clinics</label>
                            <multiselect v-model="variant.info_service_id" :options="variant.infoServices"
                              :searchable="true" label="name" track-by="id" placeholder="Select a Hospital/Clinic"
                              :multiple="false" @select="handleInfoServiceChange(variant.info_service_id.id, variant)">
                            </multiselect>
                            <span class="error text-small block" v-if="errors[`data.${index}.info_service_id`]">
                              {{ errors[`data.${index}.info_service_id`][0] }}
                            </span>
                          </div>
                          <div class="form-group col-md-12 mb-2" v-if="variant.subService_id">
                            <label class="text-">OutPatient Clinics</label>
                            <multiselect v-model="variant.external_clinic_id" :options="variant.external_clinics"
                              :searchable="true" label="name_en" track-by="id" placeholder="Select a OutPatient Clinic"
                              :multiple="false"></multiselect>
                            <span class="error text-small block"
                              v-if="errors[`data.${index}.external_clinic_service_id`]">
                              {{ errors[`data.${index}.external_clinic_service_id`][0] }}
                            </span>
                          </div>
                          <button class="btn btn-danger mt-3" @click="removeVariant(index)">
                            Remove Variant
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="Object.keys(errors).length > 0" class="error text-small block">
                  <ul>
                    <li v-for="(error, key) in errors" :key="key">
                      {{ error }}
                    </li>
                  </ul>
                </div>
              </div>
              <button type="submit" class="btn btn-primary">Submit</button>
            </form>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import { store } from "../../Store";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";

export default {
  name: "CreateDoctor",
  components: {
    Multiselect,
  },
  data() {
    return {
      name_en: "",
      name_ar: "",
      title_en: "",
      title_ar: "",
      title_type_en: "",
      title_type_ar: "",
      phone_number: "",
      email: "",
      password: "",
      gender: "",
      price: "",
      price_after_discount: "",
      experience: "",
      description_en: "",
      description_ar: "",
      user_id: "",
      main_image: null,
      additionalImages: [],
      imagePreviewUrls: [],
      
      // New field for hospital employment status
      isHospitalEmployed: "", // Will be 'yes' or 'no'

      medicalInsurances: [],
      selectedMedicalInsurances: [],

      district_id: "",
      districts: [],

      dis_Variants: [
        {
          district_id: null,
          address: '',
        },
      ],

      selectService: [
        { id: 1, name: "Hospitals" },
        { id: 2, name: "Clinics" },
      ],

      specialities: [],
      data: [],
      branches: [],
      errors: {},
    };
  },

  async created() {
    this.fetchDistricts();
    this.fetchSpecialities();
    this.fetchMedicalInsurances();
  },

  watch: {
    // Clear contact fields when switching to hospital employee
    isHospitalEmployed(newVal) {
      if (newVal === 'yes') {
        // Clear contact fields when doctor is a hospital employee
        this.phone_number = "";
        this.email = "";
        // Clear any related errors
        if (this.errors.phone_number) delete this.errors.phone_number;
        if (this.errors.email) delete this.errors.email;
      }
    }
  },

  methods: {
    handleMainImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.main_image = file;
      }
    },
    
    handleMultipleImages(event) {
      const files = Array.from(event.target.files);
      files.forEach(file => {
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.imagePreviewUrls.push(e.target.result);
          };
          reader.readAsDataURL(file);
          this.additionalImages.push(file);
        }
      });
      event.target.value = '';
    },

    removeImage(index) {
      this.additionalImages.splice(index, 1);
      this.imagePreviewUrls.splice(index, 1);
    },
    
    clearImage() {
      this.main_image = null;
      this.$refs.imageInput.value = '';
    },

    addDistrictVariant() {
      this.dis_Variants.push({
        district_id: null,
        address: '',
      });
    },
    
    removeDistrictVariant(index) {
      this.dis_Variants.splice(index, 1);
    },

    validateForm() {
      this.errors = {};

      // Validate hospital employment status
      if (!this.isHospitalEmployed) {
        this.errors.isHospitalEmployed = "Please specify if the doctor is employed by the hospital.";
      }

      // Validate phone_number and email ONLY if doctor is NOT a hospital employee
      if (this.isHospitalEmployed === 'no') {
        if (!this.phone_number || this.phone_number.trim() === '') {
          this.errors.phone_number = "Phone number is required for non-hospital doctors.";
        } else if (!/^[0-9+\-\s()]+$/.test(this.phone_number)) {
          this.errors.phone_number = "Please enter a valid phone number.";
        }

        if (!this.email || this.email.trim() === '') {
          this.errors.email = "Email is required for non-hospital doctors.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
          this.errors.email = "Please enter a valid email address.";
        }
      }

      // Validate main_image
      if (this.main_image && !['image/jpeg', 'image/jpg', 'image/png'].includes(this.main_image.type)) {
        this.errors.main_image = "Image must be a JPEG, JPG, or PNG file.";
      }

      // Validate variants
      if (this.data.length === 0) {
        this.errors.data = "At least one variant is required.";
      } else {
        this.data.forEach((variant, index) => {
          const variantErrors = {};

          if (!variant.service_id) {
            variantErrors.service_id = "Service is required.";
          }

          if (!variant.specialty_id) {
            variantErrors.specialty_id = "Specialty is required.";
          }

          if (!variant.info_service_id && !variant.external_clinic_id) {
            variantErrors.info_service_id = "Info Service or External Clinic is required.";
          }

          if (Object.keys(variantErrors).length > 0) {
            this.errors[`data.${index}`] = variantErrors;
          }
        });
      }

      return Object.keys(this.errors).length === 0;
    },

    async createDoctor() {
      try {
        if (!this.validateForm()) {
          // Scroll to top to show errors
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        
        const formData = new FormData();
        formData.append("name_en", this.name_en);
        formData.append("name_ar", this.name_ar);
        formData.append("price", Number(this.price));
        formData.append("price_after_discount", Number(this.price_after_discount));
        formData.append("description_ar", this.description_ar);
        formData.append("description_en", this.description_en);
        formData.append("experience", this.experience);
        formData.append("gender", this.gender);
        formData.append("title_type_en", this.title_type_en);
        formData.append("title_type_ar", this.title_type_ar);
        formData.append("title_ar", this.title_ar);
        formData.append("title_en", this.title_en);
        
        // Add hospital employment status
        formData.append("is_hospital_employed", this.isHospitalEmployed === 'yes');
        
        // Only append contact info if doctor is NOT a hospital employee
        if (this.isHospitalEmployed === 'no') {
          formData.append("email", this.email);
          formData.append("phone_number", this.phone_number);
        }
        
        formData.append("password", this.password);
        
        const user_id = store.user ? store.user.id : null;
        formData.append("user_id", user_id);
        
        if (this.main_image) {
          formData.append("main_image", this.main_image);
        }
        
        this.additionalImages.forEach((image) => {
          formData.append(`images[]`, image);
        });
        
        this.selectedMedicalInsurances.forEach((medicalInsurance, index) => {
          formData.append(`medical_insurance[${index}]`, medicalInsurance.id);
        });

        this.dis_Variants.forEach((variant, index) => {
          formData.append(`districts[${index}][district_id]`, variant.district_id?.id || variant.district_id);
          formData.append(`districts[${index}][address]`, variant.address);
        });

        this.data.map((variant, index) => {
          formData.append(`data[${index}][specialty_id]`, variant.specialty_id.id);

          if (variant.external_clinic_id) {
            formData.append(`data[${index}][external_clinic_service_id]`, variant.external_clinic_id.id);
          } else {
            formData.append(`data[${index}][info_service_id]`, variant.info_service_id.id);
          }
          
          if (variant.subService_id) {
            formData.append(`data[${index}][sub_service_id]`, variant.subService_id.id);
          } else {
            formData.append(`data[${index}][service_id]`, variant.service_id);
          }
        });
        
        console.log(formData);
        
        const response = await axios.post("/admin/admin/doctor/create", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        
        console.log(response.data);
        this.$router.push({ name: "all-doctors" });
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors;
          console.log("Validation errors:", this.errors);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          console.error("Error creating doctor:", error);
        }
      }
    },
    
    addVariant() {
      this.data.push({
        service_id: [],
        specialty_id: [],
        info_service_id: [],
        subService_id: [],
        external_clinic_id: [],
        selectSubService: [],
        infoServices: [],
        external_clinics: [],
      });
      this.logVariants();
    },
    
    removeVariant(index) {
      this.data.splice(index, 1);
    },
    
    logVariants() {
      console.log(this.variants);
    },
    
    async fetchMedicalInsurances() {
      try {
        const response = await axios.get("/admin/admin/medical-insurance/all");
        console.log("medical-insurance", response.data.data);
        this.medicalInsurances = response.data.data;
      } catch (error) {
        console.error(error);
      }
    },
    
    async fetchDistricts() {
      try {
        const response = await axios.get(`/admin/admin/district/all`);
        this.districts = response.data.data;
        this.meta = response.data.meta;
        console.log("districts", this.districts);
      } catch (error) {
        console.error("Error fetching districts:", error);
      }
    },
    
    async fetchSubServices(serviceId) {
      try {
        const response = await axios.get(`/admin/admin/sub-service/all?service_id=${serviceId}`);
        this.subServices = response.data.data;
        this.meta = response.data.meta;
        console.log("SubServices", response.data.data);
      } catch (error) {
        console.error("Error fetching infoServices:", error);
      }
    },
    
    async fetchSpecialities() {
      try {
        const response = await axios.get(`/admin/admin/speciality/all`);
        this.specialities = response.data.data;
        this.meta = response.data.meta;
        console.log("specialities", this.specialities);
      } catch (error) {
        console.error("Error fetching specialities:", error);
      }
    },

    async fetchInfoServices(serviceId, variant) {
      try {
        const response = await axios.get(`/admin/admin/info-service/all?service_id=${serviceId}`);
        variant.infoServices = response.data.data;
        console.log("infoServices for variant:", variant.infoServices);
      } catch (error) {
        console.error("Error fetching infoServices:", error);
      }
    },
    
    async fetchExternalClinics(infoServiceId, variant) {
      console.log("fetchExternalClinics:");
      try {
        const response = await axios.get(`/admin/admin/info-service/get?id=${infoServiceId}`);
        variant.external_clinics = response.data.data.external_clinic_service_ids || [];
        console.log('externalclinics', this.external_clinics);
        this.meta = response.data.meta;
      } catch (error) {
        console.error("Error fetching externalClinics:", error);
      }
    },
    
    handleServiceChange(selectedService, variant) {
      console.log("Selected service:", selectedService);
      console.log("Selected variant:", variant);
      variant.subService_id = ""; // Clear subService selection
      variant.info_service_id = ""; // Clear info service selection
      variant.external_clinic_id = ""; // Clear external clinic selection
      if (selectedService) {
        this.fetchInfoServices(selectedService, variant); // Pass the variant
        if (selectedService == 1) {

          variant.selectSubService = [{ id: 4, name: "OutPatient Clinics" }];
          console.log("Selected selectSubService:", variant.selectSubService)
        } else {
          variant.selectSubService = [];
        }
      } else {
        variant.infoServices = [];
        variant.selectSubService = [];
      }
    },

    handleInfoServiceChange(infoServiceId, variant) {
      console.log("Selected infoservice:", infoServiceId);

      variant.external_clinic_id = ""; // Clear external clinic selection
      if (infoServiceId) {
        this.fetchExternalClinics(infoServiceId, variant);
      } else {
        variant.external_clinics = []; // Clear clinics if no info service is selected
      }
    }
  },
};
</script>

<style scoped>
form {
  padding: 1rem;
  border: 1px solid #ccc;
  background-color: white;
  /* Add a background color */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* Add a shadow for better visibility */
  width: 100%;
  /* max-width: 500px; Optional: Max width for better responsiveness */
}

form>.form-group {
  margin-bottom: 1.5rem;
}

button {
  width: 100%;
}

.multiple-image-upload {
  margin-bottom: 1.5rem;
}

.image-preview-container {
  margin-top: 1rem;
}

.image-preview-wrapper {
  position: relative;
  margin-bottom: 1rem;
}

.preview-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.remove-image {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 2px 8px;
  font-size: 12px;
}

.upload-container {
  margin-bottom: 1rem;
}

.error {
  color: #a94442;
  font-size: 0.875em;
}
</style>